import client from './client'

const unwrapData = (res) => res.data?.data

export const getStats = (params) =>
  client.get('/stats', { params }).then(unwrapData)
